export default "__VITE_ASSET__3d83a71b__"